import { make as RecaptchaProvider } from '@porterin/feature/src/contexts/recpatcha-context/RecaptchaProvider.mjs';
import { reloadAfterRecaptchaFailure } from '@porterin/feature/src/shared/core/helpers/SharedHelper';
import { make as VehicleFareEstimateFormCmp } from '@porterin/feature/src/shared/lead-flow/view/VehicleFareEstimateFormCmp.mjs';
import {
  FareEstimateContentEntity,
  getLeadFlowVm,
} from '@porterin/feature/src/shared/lead-flow/view/view-model/LeadFlowVm';
import { VehicleModalData } from '@porterin/feature/src/shared/vehicles/types';
import VehicleModalLayoutCmp from '@porterin/feature/src/shared/vehicles/view/components/VehicleModalLayoutCmp';
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import {
  MODAL_CLOSE_TIMEOUT_NONE,
  ModalControl,
} from '../../domain/entities/ModalEntities';
import styles from '../styles/FareEstimateModal.module.scss';
import modal_form_styles from '../styles/VehicleFareEstimateFormModal.module.scss';
import input_field_styles from '../styles/VehicleFareEstimateInputModal.module.scss';

const SOURCE_KNOW_MORE = 0;
const SOURCE_MOBILE_STICKY = 2;

interface VehicleFareEstimateModalCmpProps {
  modal: ModalControl;
  service_category: string;
  vehicle: VehicleModalData | undefined;
  fare_estimate_form_content: {
    fare_estimate_content: FareEstimateContentEntity;
  };
}

function VehicleFareEstimateModalCmp({
  modal,
  service_category,
  vehicle,
  fare_estimate_form_content,
}: Readonly<VehicleFareEstimateModalCmpProps>): React.ReactElement {
  const [isRecaptchaFailed, setIsRecaptchaFailed] = useState(false);
  const fare_estimate_vm = getLeadFlowVm(
    fare_estimate_form_content.fare_estimate_content,
  );
  const { modal_state, close_modal } = modal;

  useEffect(
    () => reloadAfterRecaptchaFailure(isRecaptchaFailed),
    [isRecaptchaFailed],
  );

  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_NONE}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <RecaptchaProvider
        value={{
          isRecaptchaFailed,
          setRecaptchaState: (flag: boolean) => setIsRecaptchaFailed(flag),
        }}
      >
        <VehicleModalLayoutCmp
          modal={modal}
          modal_content={fare_estimate_vm.mobile_modal_content}
          vehicle={vehicle}
        >
          <VehicleFareEstimateFormCmp
            service_category={service_category}
            styles={modal_form_styles}
            input_field_styles={input_field_styles}
            fare_estimate_vm={fare_estimate_vm}
            source={
              vehicle === undefined ? SOURCE_MOBILE_STICKY : SOURCE_KNOW_MORE
            }
            on_lead_success_handler={() => {}}
          />
        </VehicleModalLayoutCmp>
      </RecaptchaProvider>
    </ReactModal>
  );
}

export default VehicleFareEstimateModalCmp;
